// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var RouteType;
(function (RouteType) {
    RouteType["ROUTE_TYPE_UNSPECIFIED"] = "ROUTE_TYPE_UNSPECIFIED";
    RouteType["ROUTE_TYPE_BACK"] = "ROUTE_TYPE_BACK";
    RouteType["ROUTE_TYPE_CALL_GROUP"] = "ROUTE_TYPE_CALL_GROUP";
    RouteType["ROUTE_TYPE_CALL_QUEUE"] = "ROUTE_TYPE_CALL_QUEUE";
    RouteType["ROUTE_TYPE_CALL_ROUTE"] = "ROUTE_TYPE_CALL_ROUTE";
    RouteType["ROUTE_TYPE_DEVICE"] = "ROUTE_TYPE_DEVICE";
    RouteType["ROUTE_TYPE_EXIT"] = "ROUTE_TYPE_EXIT";
    RouteType["ROUTE_TYPE_FORWARDING_NUMBER"] = "ROUTE_TYPE_FORWARDING_NUMBER";
    RouteType["ROUTE_TYPE_IVR_MENU"] = "ROUTE_TYPE_IVR_MENU";
    RouteType["ROUTE_TYPE_PLAY_MESSAGE"] = "ROUTE_TYPE_PLAY_MESSAGE";
    RouteType["ROUTE_TYPE_TOP"] = "ROUTE_TYPE_TOP";
    RouteType["ROUTE_TYPE_REPEAT"] = "ROUTE_TYPE_REPEAT";
    RouteType["ROUTE_TYPE_VOICEMAIL"] = "ROUTE_TYPE_VOICEMAIL";
})(RouteType || (RouteType = {}));
export var RouteType_index;
(function (RouteType_index) {
    RouteType_index[RouteType_index["ROUTE_TYPE_UNSPECIFIED"] = 0] = "ROUTE_TYPE_UNSPECIFIED";
    RouteType_index[RouteType_index["ROUTE_TYPE_BACK"] = 1] = "ROUTE_TYPE_BACK";
    RouteType_index[RouteType_index["ROUTE_TYPE_CALL_GROUP"] = 2] = "ROUTE_TYPE_CALL_GROUP";
    RouteType_index[RouteType_index["ROUTE_TYPE_CALL_QUEUE"] = 3] = "ROUTE_TYPE_CALL_QUEUE";
    RouteType_index[RouteType_index["ROUTE_TYPE_CALL_ROUTE"] = 4] = "ROUTE_TYPE_CALL_ROUTE";
    RouteType_index[RouteType_index["ROUTE_TYPE_DEVICE"] = 5] = "ROUTE_TYPE_DEVICE";
    RouteType_index[RouteType_index["ROUTE_TYPE_EXIT"] = 6] = "ROUTE_TYPE_EXIT";
    RouteType_index[RouteType_index["ROUTE_TYPE_FORWARDING_NUMBER"] = 7] = "ROUTE_TYPE_FORWARDING_NUMBER";
    RouteType_index[RouteType_index["ROUTE_TYPE_IVR_MENU"] = 8] = "ROUTE_TYPE_IVR_MENU";
    RouteType_index[RouteType_index["ROUTE_TYPE_PLAY_MESSAGE"] = 9] = "ROUTE_TYPE_PLAY_MESSAGE";
    RouteType_index[RouteType_index["ROUTE_TYPE_TOP"] = 10] = "ROUTE_TYPE_TOP";
    RouteType_index[RouteType_index["ROUTE_TYPE_REPEAT"] = 11] = "ROUTE_TYPE_REPEAT";
    RouteType_index[RouteType_index["ROUTE_TYPE_VOICEMAIL"] = 12] = "ROUTE_TYPE_VOICEMAIL";
})(RouteType_index || (RouteType_index = {}));
// PhoneTreeService manages phone tree configuration.
// NWX Endpoint, location-id is not used, instead, authorization is done by checking that the request token contains
// the permission PHONE_FULL_ACCESS for the tenant or primitive's tenant.
export const PhoneTreeService = {
    // Create phone tree.
    Create(fn, req) {
        return fn(`/phone/tree/beta/v2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Read phone tree.
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["phoneTreeId"], "phoneTreeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/tree/beta/v2/${req["phoneTreeId"]}?${fm.renderURLSearchParams(req, ["phoneTreeId"])}`, { method: "GET" });
    },
    // List phone trees.
    List(fn, req) {
        return fn(`/phone/tree/beta/v2?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Update phone tree.
    // Updates fields directly on a phone tree, ignoring dial options that are related to the phone tree.
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["phoneTreeId"], "phoneTreeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/tree/beta/v2/${req["phoneTreeId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // Delete phone tree.
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["phoneTreeId"], "phoneTreeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/tree/beta/v2/${req["phoneTreeId"]}?${fm.renderURLSearchParams(req, ["phoneTreeId"])}`, { method: "DELETE" });
    },
    // Update phone tree dial options.
    UpdateDialOptions(fn, req) {
        try {
            fm.validateUrlParam(req["phoneTreeId"], "phoneTreeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/tree/beta/v2/${req["phoneTreeId"]}/dial_options`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // Usage returns the usages of a phone tree aka IVR Menu.
    Usage(fn, req) {
        try {
            fm.validateUrlParam(req["phoneTreeId"], "phoneTreeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/tree/beta/v2/${req["phoneTreeId"]}/usage?${fm.renderURLSearchParams(req, ["phoneTreeId"])}`, { method: "GET" });
    },
};
